import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiUserAccessTimeComponent } from './multi-user-access-time.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UserProfileDetailsModule } from '../../user-profile/user-profile-details/user-profile-details.module';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MultiUserAccessTimeComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    UserProfileDetailsModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatIconModule,
    MatButtonModule,
    SharedLayoutModule,
    WithTooltipModule,
    TranslateModule
  ],
  exports: [MultiUserAccessTimeComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class MultiUserAccessTimeModule {}
